import { FilterData } from 'common/helpers/url';
import { PaginationView } from 'features/pagination/models/paginationModel';

export enum DownloadPaths {
    Contracts = '/download/projects',
    ContractsFilter = '/download/projects/filter',
    Benefits = '/download/benefits',
    BenefitsFilter = '/download/benefits/filter',
}

export interface DownloadRequest {
    ids?: number[];
    fileFormat: string;
    filters?: FilterData;
    downloadAll: boolean;
    exportType?: string;
    benefitType?: string;
    /**
     * Which paginated view's saved filters this export should use. The epic reads
     * the filters out of pagination state, so a view that is not the Download
     * Benefits page has to say which filters are its own. Defaults to
     * PaginationView.DownloadBenefits so existing callers are unaffected.
     */
    paginatedView?: PaginationView;
}

export interface DownloadAll {
    downloadAll?: boolean;
}

export interface InvoiceDownloadRequest {
    subscriptionId?: number;
    invoiceId?: number;
}
